import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadSingleFileImage,
  uploadSingleFileVideo,
} from "../apis/UploadImgApis";
import { AddCommercial_Api } from "../apis/CommercialApis";
import { setAllUserCommercialData, setCommercialDetails } from "../redux/action";
import { useGoBack } from "../utils";
import { toast } from "react-toastify";
import { PaymentCreateIntentApi } from "../apis/PaymentApis";
export const useCommercialHooks = () => {
  //all local states
  const [commercialData, setCommercialData] = useState({});
  const [placeNameDropdownData, setPlaceNameDropDownData] = useState([]);
  const commercial_redux = useSelector((s) => s?.commercialDetails ?? []);
  const [clientSecret, setClientSecret] = useState("");
  const [stripeModalOpen, setStripeModalOpen] = useState(false);
  const commercial_All_data_redux = useSelector(
    (s) => s?.allCommercialData ?? []
  );
  const allNearPlaces_Redux = useSelector(
    (s) => s?.allNearCommercialData ?? []
  );
  const allUserCommercialData_redux = useSelector(
    (s) => s?.allUserCommercialData ?? []
  );
  const popularCommercialData_redux = useSelector(
    (s) => s?.allPopularCommercialData ?? []
  );

  //all navigation
  const goBack = useGoBack();

  //all redux
  const placeDetails = useSelector((s) => s?.allPlacesData ?? []);

  const dispatch = useDispatch();

  //all useEffect
  useEffect(() => {
    if (placeDetails?.length > 0) {
      setPlaceNameDropDownData(placeDetails);
    }
  }, [placeDetails]);

  //all functions
  //validation
  const isFormValid =
    commercialData?.name?.trim() &&
    commercialData?.place?.length > 0 &&
    commercialData?.types?.length > 0 &&
    commercialData?.description?.trim() &&
    commercialData?.mediaUrl;

  const onPressPayNowBtn = () => {
    let videoObj = {
      "video-file": commercialData?.mediaUrl,
    };
    toast("Uploading commercial....")
    if (videoObj) {
      uploadSingleFileVideo(videoObj).then((e) => {
        let payload = {
          name: commercialData?.name,
          place: commercialData?.place?.[0]?._id,
          types: commercialData?.types,
          description: commercialData?.description,
          mediaUrl: e?.data,
        };

        AddCommercial_Api(payload).then((e) => {
          if (e?.commercial) {
            dispatch(
              setAllUserCommercialData([e?.commercial, ...commercial_redux])
            );

            let paymentPayload = {
              contentType: "commercial",
              contentId: e?.commercial?._id,
              amount: 20,
            };
            PaymentCreateIntentApi(paymentPayload).then((res) => {
              console.log("response of intent is ==> ", res);
              if (res?.success) {
                const { clientSecret, customer, ephemeralKey } = res?.data;
                setClientSecret(clientSecret);
                setStripeModalOpen(true);
              }
            })

          }
          else toast.error("Something went wrong commercial cannot be added")
        });
      });
    }
  };

  //get all commercial hoook

  //your commercial data

  //all local states

  const [yourCommercialData, setYourCommercialData] = useState([]);

  //all useEFFECT

  useEffect(() => {
    if (commercial_All_data_redux?.length > 0) {
      setYourCommercialData(commercial_All_data_redux);
    }
  }, [commercial_All_data_redux]);
  return {
    //all local states
    commercialData,
    setCommercialData,
    placeNameDropdownData,
    //validation
    isFormValid,
    //all functions
    onPressPayNowBtn,

    //all commercial.js state

    //all local states
    commercial_All_data_redux,
    popularCommercialData_redux,
    allNearPlaces_Redux,
    allUserCommercialData_redux,
    clientSecret,
    setClientSecret,
    stripeModalOpen,
    setStripeModalOpen
  };
};
